export default "__VITE_ASSET__BgrprK0y__"